<template>
  <MapControl :center="getCenter()" :scale="6" :markers="getMarkers()"></MapControl>
</template>

<script>
import MapControl from "@/controls/MapControl";

export default {
  name: "HotelMap",
  components: {
    MapControl,
  },
  data() {
    return {
      AllHotels: [],
    }
  },
  mounted() {
    if (this.$route.query.point === undefined) {
      this.$router.go(-1)
    } else
      this.AllHotels = this.$route.query.point
  },
  methods: {
    getCenter() {
      if (this.AllHotels.length === 0)
        return {lng: 0, lat: 0}
      else
        return {lng: this.AllHotels[0].data.jDJD, lat: this.AllHotels[0].data.jDWD}
    },
    getMarkers() {
      let that = this
      let markers = []
      that.AllHotels.forEach(item => {
        let P = item.data.iD
        let image_div = '<div><img src="' + item.data.jDTP + '" width="300" alt=""></div>'
        let jqdh = '<div><span style="text-align: center;font-size: 1rem;color: blue">酒店电话：</span><span style="text-align: center;font-size: 1rem">' + item.data.jDDH + '</span></div>'
        let text_div = '<a href="javascript:test(\'' + P + '\')" style="color: #2986de;font-size: 1.2rem">' + item.data.jDMC + '</a>'
        let content = '<div>' + image_div + (item.data.jDDH ? jqdh : '') + text_div + '</div>'

        let m = {content: content, point: {lng: item.data.jDJD, lat: item.data.jDWD}}
        markers.push(m)
      })
      return markers
    },
  }
}
</script>

<style scoped>

</style>
